






































import { Vue, Component, Prop } from 'vue-property-decorator';

import { Surface } from '@/components/atoms';
import {
  EBusinessReferralType,
  IBusinessReferral
} from '@/models/marketingCenter/referral';
import PreviewReferral from '@/components/molecules/Referral/PreviewReferral/PreviewReferral.vue';
import ReferralBoth from '@/components/icons/ReferralBoth.vue';
import ReferralNew from '@/components/icons/ReferralNew.vue';
import ReferralExisting from '@/components/icons/ReferralExisting.vue';
import Typography from '@/componentsV2/atoms/Typography/Typography.vue';

@Component({
  components: {
    Surface,
    Typography,
    PreviewReferral,
    ReferralBoth,
    ReferralNew,
    ReferralExisting
  }
})
export default class CampaignSettingsOverview extends Vue {
  @Prop() campaign!: IBusinessReferral;

  get type() {
    if (!this.coins) return 'referred';
    if (!this.percentage) return 'referring';

    return 'both';
  }

  get referring() {
    return {
      title: 'Referring:',
      value: `${this.coins} ${this.$tc(
        `common.pluralize.coin`,
        this.coins || 1
      )}`
    };
  }
  get referred() {
    return {
      title: 'Referred:',
      value: this.$t(`${this.tPrefix}.referredValue`, {
        value: this.percentage
      })
    };
  }

  get isReferring() {
    return this.type === EBusinessReferralType.REFERRING;
  }

  get isReferred() {
    return this.type === EBusinessReferralType.REFERRED;
  }

  get coins() {
    return Number(this.campaign.referringDiscount);
  }

  get percentage() {
    return Number(this.campaign.referredDiscount);
  }

  get tPrefix() {
    return 'referralProgram.campaign';
  }
}
